import { useContext } from 'react'

import Context from './context'

interface PanelProps {
  children: React.ReactElement
}

const AccordionPanel: React.FC<PanelProps> = ({ children }) => {
  const { active } = useContext(Context)

  return active ? children : null
}

export default AccordionPanel
